import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Image,
  Text,
  useDisclosure,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import TableLocking from "./tableLocking";
import IconFile from "../../assets/images/booking/upfile.svg";
import iconPlus from "../../assets/images/booking/plus.svg";
import PopupImport from "../../components/popup/PopupImport";
import toast from "react-hot-toast";
import { lockingCall } from "../../api/locking";
import { lockingImageCall } from "../../api/lockingImage";
import { lockingParticipantCall } from "../../api/lockingParticipant";
import { exportFile } from "../../utils/tools";
import { formatDateToLocal } from "../../utils/utils";
import { useLocking } from "../../hooks/useLooking";
import FormAdd from "./form/add";
import iconFile from "../../assets/images/apartment/Frame.svg";
import { exportExcelFromApi } from "../../utils/tools";
import iconExcel from "../../assets/images/employee/iconExcel.svg";
import TransactionDetailModal from "../../components/transations/TransactionDetailModal";

const columnMappingReverse = {
  "Mã phiếu booking": "bookingCode",
  "Mã dự án": "projectCode",
  "Mã khách hàng": "customerCode",
  "Mã căn hộ": "apartmentCode",
  "Ngày locking": "bookingTime",
  "Số tiền locking": "price",
  "Ghi chú locking": "note",
};

const columnMappingImportReverse = {
  "Tên dự án": "projectName",
  "Mã căn hộ": "apartmentCode",
  "Ngày locking": "bookingTime",
  "Số tiền locking": "price",
  "Ghi chú locking": "note",

  "Tên khách hàng hoặc công ty": "customerName",
  "Mã CCCD": "identificationNumber",
  "Mã số thuế": "businessTaxCode",

  "Tên đại lý": "agentName",
};

export default function Locking() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const transactionModal = useDisclosure();

  const { refetch, isRefetching } = useLocking();

  const [paramExport, setParamExport] = useState(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupImportAgentVisible, setPopupImportAgentVisible] = useState(false);

  const [transactionApprove, setTransactionApprove] = useState({
    id: null,
    type: null,
    status: null,
    submit: null,
  });

  const [confirmLoading, setConfirmLoading] = useState(false);

  useEffect(() => {
    const handleOpenTransactionDetail = (event) => {
      const detail = event.detail || {};

      setTransactionApprove({
        id: detail.id,
        type: detail.type || "LOCKING",
        status: detail.status || "APPROVED",
        submit: detail.submit,
      });

      transactionModal.onOpen();
    };

    window.addEventListener(
      "OPEN_TRANSACTION_DETAIL_MODAL",
      handleOpenTransactionDetail
    );

    return () => {
      window.removeEventListener(
        "OPEN_TRANSACTION_DETAIL_MODAL",
        handleOpenTransactionDetail
      );
    };
  }, [transactionModal]);

  const handleConfirmTransaction = async ({ refetch: refetchDetail }) => {
    if (!transactionApprove?.submit || !transactionApprove?.id) return;

    setConfirmLoading(true);

    try {
      await transactionApprove.submit(
        transactionApprove.status || "APPROVED",
        transactionApprove.id
      );

      await refetch();

      if (refetchDetail) {
        await refetchDetail();
      }

      transactionModal.onClose();

      setTransactionApprove({
        id: null,
        type: null,
        status: null,
        submit: null,
      });
    } catch (error) {
      console.log("confirm locking transaction error:", error);
    } finally {
      setConfirmLoading(false);
    }
  };

  const onSubmitAdd = async (data) => {
    console.log(data);
    const toastCreate = toast.loading("Đang thêm locking ...");

    try {
      const filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null
        )
      );

      if (filteredData?.bookingTime) {
        filteredData.bookingTime = formatDateToLocal(filteredData.bookingTime);
      }

      const { delegationImage, employeeProject, ...dataFilter } = filteredData;

      delete dataFilter?.delegationImage;
      delete dataFilter?.createdAt;

      const dataCreateLocking = await lockingCall.create({
        ...dataFilter,
      });

      if (dataCreateLocking?._id) {
        let createDataEmployeeManager = [];

        if (employeeProject) {
          createDataEmployeeManager = employeeProject.map((item) => {
            if (item?.id) {
              delete item?.id;
            }

            item.lockingId = dataCreateLocking?._id;
            return item;
          });
        }

        if (createDataEmployeeManager.length > 0) {
          await lockingParticipantCall.createAndUpdateMany({
            lockingId: dataCreateLocking?._id,
            list: createDataEmployeeManager,
          });
        }

        if (delegationImage && delegationImage.length > 0) {
          const paths = delegationImage
            ?.filter((img) => img.path)
            .map((img) => img.path);

          await lockingImageCall.createMany({
            lockingId: dataCreateLocking?._id,
            path: paths,
            type: "TRANSACTION",
          });
        }
      }

      await refetch();
      onClose();
      toast.success("Thêm thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }

    toast.dismiss(toastCreate);
  };

  const handleExportSample = () => {
    const columnMapping = {
      bookingCode: "Mã phiếu locking",
      projectCode: "Mã dự án",
      customerCode: "Mã khách hàng",
      apartmentCode: "Mã căn hộ",
      bookingTime: "Ngày locking",
      price: "Số tiền locking",
      note: "Ghi chú locking",
    };

    const data = [
      {
        bookingCode: "MSH_BOOKING_1",
        projectCode: "MSHDA_1",
        customerCode: "MSH_KH_1",
        apartmentCode: "AP001",
        bookingTime: "2024-11-17",
        price: 1000000000,
        note: "abc",
      },
      {
        bookingCode: "MSH_BOOKING_2",
        projectCode: "MSHDA_2",
        customerCode: "MSH_KH_2",
        apartmentCode: "AP002",
        bookingTime: "2024-11-17",
        price: 1000000000,
        note: "abc",
      },
      {
        bookingCode: "MSH_BOOKING_3",
        projectCode: "MSHDA_3",
        customerCode: "MSH_KH_3",
        apartmentCode: "AP003",
        bookingTime: "2024-11-17",
        price: 1000000000,
        note: "abc",
      },
    ];

    try {
      exportFile(data, columnMapping, "bang_locking.xlsx");
      toast.success("Download file thành công");
    } catch (error) {
      toast.error("Export lỗi");
      console.log(error);
    }
  };

  const handleExportAgentSample = () => {
    const columnMapping = {
      projectName: "Tên dự án",
      apartmentCode: "Mã căn hộ",
      bookingTime: "Ngày locking",
      price: "Số tiền locking",
      note: "Ghi chú locking",

      customerName: "Tên khách hàng hoặc công ty",
      identificationNumber: "Mã CCCD",
      businessTaxCode: "Mã số thuế",

      agentName: "Tên đại lý",
    };

    const data = [
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        bookingTime: "2024-11-17",
        price: "100,000,000.1",
        note: "abc",
        customerName: "Nguyễn Quốc Đạt",
        identificationNumber: "030200007777",
        agentName: "Đại lý MSH",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        bookingTime: "2024-11-17",
        price: "100,000,000.1",
        note: "abc",
        customerName: "MSH Group",
        businessTaxCode: "777",
        agentName: "Đại lý MSH",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        bookingTime: "2024-11-17",
        price: "100,000,000.1",
        note: "abc",
        customerName: "Phạm Đức Trung",
        identificationNumber: "030200001111",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        bookingTime: "2024-11-17",
        price: "100,000,000.1",
        note: "abc",
        customerName: "MSH Group",
        businessTaxCode: "777",
      },
      {
        projectName: "VINACONEX DIAMOND TOWER",
        apartmentCode: "0601",
        bookingTime: "2024-11-17",
        price: "100,000,000.1",
        note: "abc",
      },
    ];

    try {
      exportFile(data, columnMapping, "bang_locking_dai_ly.xlsx");
      toast.success("Download file thành công");
    } catch (error) {
      toast.error("Export lỗi");
      console.log(error);
    }
  };

  const handleExport = async () => {
    const columnMapping = {
      status: "Trạng thái",
      statusTtkqSalesContract: "Đã lên TTKQ/HĐMB",
      inputLate: "Nhập CTV muộn",
      customerName: "Tên khách hàng",
      customerPhone: "SĐT khách hàng",
      apartmentCode: "Mã căn",
      projectName: "Dự án",
      bookingTime: "Ngày đặt cọc",
      saleOpeningEvent: "Đợt mở bán",
      price: "Số tiền cọc",
      bookerCode: "Mã nhân viên tạo",
      bookerName: "Họ tên nhân viên tạo",
      saleBlock: "Khối",
      saleArea: "Vùng",
      createdAt: "thời gian tạo locking",
    };

    await exportExcelFromApi({
      fetcher: () => lockingCall.export(paramExport),
      mapping: columnMapping,
      filename: "bang_quan_ly_locking.xlsx",
      toastMessages: {
        loading: "Đang tải dữ liệu & xuất file...",
        success: "Xuất file thành công",
        noData: "Không có dữ liệu",
        error: "Xuất file thất bại",
      },
    });
  };

  return (
    <Box
      w={{ base: "100%" }}
      backgroundColor="var(--color-backgroundmain)"
      p={{ base: "24px 16px 16px" }}
    >
      <Flex alignItems={"center"} justifyContent={"space-between"}>
        <Flex alignItems={"center"} gap={{ base: "74px" }}>
          <Text fontSize={{ base: "20px" }} fontWeight={600}>
            Quản lý locking
          </Text>
        </Flex>

        <Flex alignItems={"center"} gap={"16px"}>
          <Menu>
            <MenuButton
              w={"180px"}
              h={"44px"}
              as={Button}
              p="10px 16px"
              backgroundImage="var(--color-button)"
              _hover={{
                filter: "brightness(90%)",
              }}
            >
              <Flex alignItems="center" gap="8px" w={"full"}>
                <Image src={IconFile} />
                <Text
                  fontSize="15px"
                  fontWeight={600}
                  color="var(--color-main)"
                >
                  Tải file lên
                </Text>
              </Flex>
            </MenuButton>

            <MenuList>
              <MenuItem
                onClick={() => setPopupVisible(true)}
                gap={"16px"}
                p={"10px 16px"}
                _hover={{
                  filter: "brightness(96%)",
                }}
              >
                <Image src={iconFile} /> Import locking
              </MenuItem>

              <MenuItem
                onClick={() => setPopupImportAgentVisible(true)}
                gap={"16px"}
                p={"10px 16px"}
                _hover={{
                  filter: "brightness(96%)",
                }}
              >
                <Image src={iconFile} /> Import locking Đại lý
              </MenuItem>
            </MenuList>
          </Menu>

          <Button
            w={"176px"}
            h={"44px"}
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            background="var(--linear-gradient-employee)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={onOpen}
          >
            <Image src={iconPlus} />

            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Thêm locking
            </Text>
          </Button>

          <Button
            display={"flex"}
            alignItems={"center"}
            p={"10px 16px 10px 12px"}
            gap={"8px"}
            h={"44px"}
            backgroundImage="var(--linear-gradient-excel)"
            _hover={{
              filter: "brightness(90%)",
            }}
            onClick={handleExport}
          >
            <Image src={iconExcel} />

            <Text
              fontSize={{ base: "15px" }}
              fontWeight={600}
              color="var(--color-main)"
            >
              Xuất dữ liệu locking
            </Text>
          </Button>
        </Flex>
      </Flex>

      <Box mt={{ base: "23px" }}>
        <TableLocking
          isRefetchingWithCreate={isRefetching}
          setParamExport={setParamExport}
        />
      </Box>

      {popupVisible && (
        <PopupImport
          isOpen={popupVisible}
          onClose={() => setPopupVisible(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingReverse}
          handleExport={handleExportSample}
          titleAdd="Thêm danh sách locking"
          inputAdd="Nhập danh sách locking"
          type={"locking"}
        />
      )}

      {popupImportAgentVisible && (
        <PopupImport
          isOpen={popupImportAgentVisible}
          onClose={() => setPopupImportAgentVisible(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingImportReverse}
          handleExport={handleExportAgentSample}
          titleAdd="Thêm danh sách locking đại lý"
          inputAdd="Nhập danh sách locking đại lý"
          type={"lockingAgent"}
          isTypePrice={true}
        />
      )}

      <FormAdd
        isOpen={isOpen}
        onClose={onClose}
        isEdit={false}
        onSubmit={onSubmitAdd}
      />

      <TransactionDetailModal
        isOpen={transactionModal.isOpen}
        onClose={transactionModal.onClose}
        id={transactionApprove.id}
        type={transactionApprove.type}
        onConfirm={handleConfirmTransaction}
        confirmLoading={confirmLoading}
      />
    </Box>
  );
}